import moment from 'moment';

export function removeCSSClass(ele, cls) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
}

export function addCSSClass(ele, cls) {
    ele.classList.add(cls);
}

export const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;

export function formatUtcToLocal(dateStr, format = 'DD/MM/YYYY hh:mm:ss A') {
  if (!dateStr) return '';
  const str = String(dateStr).trim();
  if (/[zZ]|[+\-]\d{2}:?\d{2}$/.test(str)) {
    return moment(str).local().format(format);
  }
  return moment.utc(str).local().format(format);
}
